(function(){
  function enhance(root=document){
    root.querySelectorAll('.pv:not([data-pv-ready])').forEach((wrap)=>{
      wrap.setAttribute('data-pv-ready','1');

      const src    = wrap.getAttribute('data-src')    || '';
      const poster = wrap.getAttribute('data-poster') || '';
      const aspect = wrap.getAttribute('data-aspect') || '1/1';

      // Reuse or create <video>
      let video = wrap.querySelector('video');
      if (!video) {
        video = document.createElement('video');
        wrap.appendChild(video);
      }
      video.classList.add('pv-media');
      video.setAttribute('playsinline','');
      video.setAttribute('preload','metadata');
      if (src)    video.src = src;
      if (poster) video.setAttribute('poster', poster);
      wrap.style.setProperty('--pv-aspect', aspect);
      // Inline aspect for older browsers that ignore custom prop on child
      try { video.style.aspectRatio = aspect; } catch(e){}

      // Reuse or create controls
      let playBtn  = wrap.querySelector('.pv-play');
      let pauseBtn = wrap.querySelector('.pv-pause');
      if (!playBtn) {
        playBtn = document.createElement('button');
        playBtn.className = 'pv-ctrl pv-play';
        playBtn.type = 'button';
        playBtn.setAttribute('aria-label','Play');
        playBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none"><g filter="url(#filter0_i_155_2656)"><path d="M30.4814 0C47.3161 0 60.9639 13.6478 60.9639 30.4824C60.9637 47.3169 47.316 60.9639 30.4814 60.9639C13.6469 60.9638 0.000196157 47.3168 0 30.4824C0 13.6478 13.6468 4.22654e-05 30.4814 0ZM25.7188 19.3008C24.4487 18.5912 22.8613 19.4788 22.8613 20.8984V40.0654C22.8615 41.485 24.4488 42.3718 25.7188 41.6621L42.8652 32.0791C44.1353 31.3692 44.1351 29.5947 42.8652 28.8848L25.7188 19.3008Z" fill="white" fill-opacity="0.9"></path></g><defs><filter id="filter0_i_155_2656" x="0" y="0" width="60.9639" height="62.1639" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1.2"></feOffset><feGaussianBlur stdDeviation="0.6"></feGaussianBlur><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"></feColorMatrix><feBlend mode="normal" in2="shape" result="effect1_innerShadow_155_2656"></feBlend></filter></defs></svg>';
        wrap.appendChild(playBtn);
      }
      if (!pauseBtn) {
        pauseBtn = document.createElement('button');
        pauseBtn.className = 'pv-ctrl pv-pause';
        pauseBtn.type = 'button';
        pauseBtn.setAttribute('aria-label','Pause');
        pauseBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7h3v10H8V7zm5 0h3v10h-3V7z" fill="currentColor"/></svg>';
        pauseBtn.hidden = true;
        wrap.appendChild(pauseBtn);
      }

      const showPlay  = ()=>{ playBtn.hidden = false; pauseBtn.hidden = true; };
      const showPause = ()=>{ playBtn.hidden = true;  pauseBtn.hidden = false; };
      const play  = () => { 
        console.log("playing")
        document.querySelectorAll(".pv video").forEach((vid) => {
          vid.pause()
        })
        video.play().then(showPause).catch(showPlay);
      }
      const pause = ()=> { video.pause(); showPlay(); };
      const toggle= ()=> video.paused ? play() : pause();

      // Remove old listeners if re-enhancing
      wrap._pvCleanup?.();

      playBtn.addEventListener('click', play);
      pauseBtn.addEventListener('click', pause);
      video.addEventListener('click', toggle);
      video.addEventListener('play',  showPause);
      video.addEventListener('pause', showPlay);
      video.addEventListener('ended', showPlay);
      const onKey = (e)=>{ if (e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); toggle(); } };
      playBtn.addEventListener('keydown', onKey);
      pauseBtn.addEventListener('keydown', onKey);
      const onVis = ()=>{ if (document.hidden && !video.paused) pause(); };
      document.addEventListener('visibilitychange', onVis);

      wrap._pvCleanup = ()=> {
        playBtn.removeEventListener('click', play);
        pauseBtn.removeEventListener('click', pause);
        video.removeEventListener('click', toggle);
        video.removeEventListener('play',  showPause);
        video.removeEventListener('pause', showPlay);
        video.removeEventListener('ended', showPlay);
        playBtn.removeEventListener('keydown', onKey);
        pauseBtn.removeEventListener('keydown', onKey);
        document.removeEventListener('visibilitychange', onVis);
      };
    });
  }

  // Expose globally and auto-run on DOMReady
  window.enhancePlayableVideos = enhance;
  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', ()=>enhance());
})();

